<template>
  <div>
    <!-- 筛选 -->
    <div style="display:flex">
      <!-- 只选择目的地 -->
      <select-dest :cbPath="false"
                   @selectDest="selectDest"
                   placeholder="请选择目的地城市"
                   :selectInputWidth="150"></select-dest>
      <!-- 选择所在目的地 region区 -->
      <el-select size="mini"
                 style="margin-left:10px;width:130px"
                 v-model="region"
                 filterable
                 @change="selectArea"
                 placeholder="请选择位置">
        <el-option v-for="item in regionList"
                   :key="item.value"
                   :label="item.loc_name"
                   :value="item.loc_id"></el-option>
      </el-select>
      <!-- 酒店/民宿 类型 -->
      <el-select v-model="type"
                 size="mini"
                 style="margin-left:10px;width:100px"
                 @change="renewResidenceType"
                 placeholder="请选类型">
        <el-option v-for="item in typeList"
                   :key="item.value"
                   :label="item.lable"
                   :value="item.value">
        </el-option>
      </el-select>
      <!-- 搜索 -->
      <el-input size="mini"
                style="width:20%;margin-left:20px"
                placeholder="请输入搜索内容"
                v-model="keyword"
                clearable>
        <el-button slot="append"
                   @click="searchButton"
                   icon="el-icon-search"></el-button>
      </el-input>

    </div>

    <!-- 列表 -->
    <el-table :data="residenceData"
              style="width: 100%">
      <el-table-column label="">
        <template slot-scope="image">

          <el-image fit="fill"
                    style="width: 200px; height: 100px"
                    :preview-src-list="[]"
                    :src="image.row.residence_cover"></el-image>

        </template>
      </el-table-column>
      <!-- 名字、信息、定位 -->
      <el-table-column label=""
                       width="180">
        <template slot-scope="info">
          <div>{{info.row.residence_name}}</div>
          <div>位置</div>
        </template>
      </el-table-column>
      <el-table-column prop="name"
                       label=""
                       width="180">
        <template slot-scope="type">
          <el-tag size="mini"
                  v-if="type.row.residence_type == '1'">酒店</el-tag>
          <el-tag size="mini"
                  v-if="type.row.residence_type == '2'">民宿</el-tag>
          <el-tag size="mini"
                  v-if="type.row.residence_type == '3'">别墅</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="address"
                       label="">
        <template slot-scope="dest">
          {{dest.row.city}} / {{dest.row.region}} </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column prop="address"
                       label="">
        <template slot-scope="opeart">
          <el-button size="mini"
                     type="primary"
                     @click="addResidence(opeart.row)">添加</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DestSelect from '../../components/common/select/SelectDest'

export default {
  name: 'selece-residene-list',
  components: {
    'select-dest': DestSelect,
  },
  data() {
    return {
      region: '',
      city: '',
      keyword: '',
      type: '',
      regionList: [],
      residenceData: [],
      //
      typeList: [
        {
          lable: '酒店',
          value: 1,
        },
        {
          lable: '民宿',
          value: 2,
        },
        {
          lable: '别墅',
          value: 3,
        },
      ],
    }
  },
  mounted() {
    this.getResidenceList()
  },
  methods: {
    selectDest(value) {
      // console.log(value)
      this.city = value
      // 发送请求获得分区，发给分区选择器
      this.$http.post('/get_dest', { pid: value }).then((res) => {
        console.log(res)
        const { data, errno, errmsg } = res.data
        if (errno == '0') {
          this.regionList = data
        }
      })
    },
    selectArea(value) {
      console.log(value)
    },
    searchButton() {
      this.getResidenceList()
    },
    renewResidenceType() {},
    // 添加 酒店/民宿
    addResidence(item) {
      let residenct_id = item.id
      this.$http
        .get(`/traver/get_residence_info?residence_id=${residenct_id}`)
        .then((res) => {
          if (res.data.errno == '0') {
            // console.log(res)
            let residence_info = res.data.data
            residence_info.TrafficPlan = []
            console.log('点击添加酒店', residence_info)
            this.$emit('addResidenceToDayTrip', residence_info)
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    getResidenceList() {
      console.log(this.city)
      this.$http
        .get(
          `/traver/get_residence_list?city=${this.city}&region=${this.region}&residence_name=${this.keyword}&type=${this.type}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.residenceData = res.data.data
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
  },
}
</script>

<style>
</style>